export default {
  TOP: 'top',
  CENTER: 'center',
  BOTTOM: 'bottom',
};
